export default __webpack_public_path__ + "static/media/1917.d2cc0dd2.png";